<template>
  <div class="share-qrcode-container" v-if="isVisible">
    <div class="close-btn" @click="closeQrcode">
      <i class="el-icon-close"></i>
    </div>
    <div class="qrcode-content">
      <!-- 二维码区域 -->
      <div class="qrcode-wrapper">
        <div ref="qrCodeDiv"></div>
        <div class="qrcode-tip">手机扫码查看</div>
      </div>
      
      <!-- 链接区域 -->
<!--      <div class="share-link-area">
        <el-input
          v-model="shareUrl"
          size="small"
          readonly
          class="share-link-input"
        >
          <el-button
            slot="append"
            icon="el-icon-document-copy"
            @click="copyLink"
          >复制</el-button>
        </el-input>
      </div>-->
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: 'ShareQrcode',
  components: {
    qrcode: QRCode,
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  created() {
    },
  data() {
    return {
      isVisible: this.visible,
      shareUrl: '',
      qrcodeOptions: {
        width: 200,
        margin: 0,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      },
      platforms: [
        { name: '微信', icon: 'el-icon-chat-dot-square', type: 'wechat' },
        { name: '朋友圈', icon: 'el-icon-share', type: 'timeline' },
        { name: '微博', icon: 'el-icon-s-promotion', type: 'weibo' },
        { name: 'QQ', icon: 'el-icon-message', type: 'qq' }
      ]
    }
  },
  watch: {
    url: {
      immediate: true,
      handler(val) {
        if (val) {
          this.shareUrl = process.env.VUE_APP_SHARE_BASE + val
          // 生成二维码
          this.$nextTick(() => {
            // 清空之前的二维码
            if (this.$refs.qrCodeDiv) {
              this.$refs.qrCodeDiv.innerHTML = ''
              new QRCode(this.$refs.qrCodeDiv, {
                text: this.shareUrl,
                width: 120,
                height: 120,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
              })
            }
          })
        }
      }
    },
    visible(val) {
      this.isVisible = val;
    }
  },
  methods: {
    copyLink() {
      const input = document.createElement('input')
      input.value = this.shareUrl
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('链接已复制到剪贴板')
    },
    closeQrcode() {
      this.isVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    shareTo(type) {
      let shareUrl = ''
      const encodedUrl = encodeURIComponent(this.shareUrl)
      const encodedTitle = encodeURIComponent(this.title)
      const encodedContent = encodeURIComponent(this.content || this.title)

      switch (type) {
        case 'wechat':
          // 微信分享通常是通过二维码扫描，这里可以提示用户
          this.$message.info('请使用微信扫描二维码分享')
          break
        case 'timeline':
          // 朋友圈分享通常是通过二维码扫描，这里可以提示用户
          this.$message.info('请使用微信扫描二维码分享到朋友圈')
          break
        case 'weibo':
          shareUrl = `https://service.weibo.com/share/share.php?url=${encodedUrl}&title=${encodedTitle}`
          window.open(shareUrl, '_blank')
          break
        case 'qq':
          shareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodedUrl}&title=${encodedTitle}&desc=${encodedContent}`
          window.open(shareUrl, '_blank')
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.share-qrcode-container {
  position: fixed;
  left: 15%;
  top: 40%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  
  .close-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      background-color: #e0e0e0;
      transform: rotate(90deg);
    }
    
    i {
      font-size: 16px;
      color: #666;
    }
  }
  
  &:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
  }
  
  .qrcode-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .qrcode-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
    
    .qrcode-tip {
      margin-top: 12px;
      font-size: 14px;
      color: #666;
      font-weight: 500;
      position: relative;
      padding-bottom: 4px;
      
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background-color: #409EFF;
        border-radius: 2px;
      }
    }
  }
  
  .share-link-area {
    width: 100%;
    
    .share-link-input {
      width: 100%;
      
      ::v-deep .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
      
      ::v-deep .el-input-group__append {
        background-color: #409EFF;
        border-color: #409EFF;
        color: white;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          background-color: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }
  }
}
</style>